import * as React from "react";

export const SvgTime = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g fill={props.color ?? "#A8A8A8"}>
			<path d="M9.999.833A9.167 9.167 0 1 0 19.165 10 9.178 9.178 0 0 0 10 .833Zm0 16.667a7.5 7.5 0 1 1 7.5-7.5 7.509 7.509 0 0 1-7.5 7.5Z" />
			<path d="M10.667 10.488V5.833a.833.833 0 1 0-1.667 0v5c0 .221.088.433.244.59l2.5 2.5a.833.833 0 0 0 1.178-1.179l-2.255-2.256Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h20v20H0z" />
			</clipPath>
		</defs>
	</svg>
);
